import React from "react";
import { venueDay, matchZone } from "./matchTime";

export function scheduleDateShift(review, match) {
  const before = venueDay(review?.previousStartDate, review?.previousTimeZone || matchZone(match));
  const after = venueDay(match.startDate || match.matchDate, matchZone(match));
  return before && after ? Math.round((Date.parse(after) - Date.parse(before)) / 86400000) : 0;
}
export function shiftScheduleDates(schedule, days) {
  return schedule.map(item => {
    const value = Date.parse(`${item.date}T12:00:00Z`);
    return { ...item, date: Number.isFinite(value) ? new Date(value + days * 86400000).toISOString().slice(0, 10) : item.date };
  });
}
export default function ScheduleReview({ match, review, checked, onChange, onShift }) {
  if (!review?.required) return null;
  const days = scheduleDateShift(review, match);
  return <div className="dp-notice ds-schedule-review">
    <h3>Review the schedule after rescheduling</h3>
    <p>The match timing changed. The old schedule is hidden from competitors until you review and publish it again. Check every date and time below, including any activities outside the match dates.</p>
    {onShift && days !== 0 && <button type="button" className="dp-button" onClick={() => onShift(days)}>Move schedule dates {Math.abs(days)} {Math.abs(days) === 1 ? "day" : "days"} {days > 0 ? "later" : "earlier"}</button>}
    <label className="ds-review-check"><input type="checkbox" checked={checked} onChange={event => onChange(event.target.checked)} />I reviewed the schedule against the new match dates and time zone.</label>
  </div>;
}
